<script>
import { required, email } from "vuelidate/lib/validators";
import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";
import { getAgreementDocs } from "@/utils/agreement";
import { DEFAULT_LOCALE } from "@/utils/locale";
export default {
  page() {
    return {
      title: this.$t("register.text"),
    };
  },
  data() {
    return {
      user: { username: "", email: "", password: "" },
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      agreementChecked: false,
      agreements: [],
      agreementPreviewVisible: false,
      currentAgreement: null,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    }
  },
  validations: {
    user: {
      username: { required },
      email: { required, email },
      password: { required }
    }
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
    this.loadAgreements();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    loadAgreements() {
      const locale = (this.$i18n && this.$i18n.locale) || DEFAULT_LOCALE;
      getAgreementDocs(locale).then((docs) => {
        this.agreements = docs;
      });
    },
    openAgreement(item) {
      this.currentAgreement = item;
      this.agreementPreviewVisible = true;
    },
    // Try to register the user in with the email, username
    // and password they provided.
    tryToRegisterIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (!this.agreementChecked) {
          this.regError = "请先阅读并同意全部协议";
          this.isRegisterError = true;
          return;
        }

        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToRegister = true;
          // Reset the regError if it existed.
          this.regError = null;
          return (
            this.register({
              email: this.user.email,
              password: this.user.password
            })
              // eslint-disable-next-line no-unused-vars
              .then(token => {
                this.tryingToRegister = false;
                this.isRegisterError = false;
                this.registerSuccess = true;
                if (this.registerSuccess) {
                  this.$router.push(
                    this.$route.query.redirectFrom || { name: "home" }
                  );
                }
              })
              .catch(error => {
                this.tryingToRegister = false;
                this.regError = error ? error : "";
                this.isRegisterError = true;
              })
          );
        } else {
          const { email, username, password } = this.user;
          if (email && username && password) {
            this.registeruser(this.user);
          }
        }
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="https://i2.aic.la/200930/6dad64019f702.png" width="100%" alt="logo" />
                          </a>
                        </div>
                        <h4 class="font-size-18 mt-4">{{ $t("register.button") }}</h4>
                      </div>

                      <div class="p-2 mt-5">
                        <b-alert
                          v-model="registerSuccess"
                          class="mt-3"
                          variant="success"
                          dismissible
                        >{{ $t("register.success") }}</b-alert>

                        <b-alert
                          v-model="isRegisterError"
                          class="mt-3"
                          variant="danger"
                          dismissible
                        >{{regError}}</b-alert>

                        <b-alert
                          variant="danger"
                          class="mt-3"
                          v-if="notification.message"
                          show
                          dismissible
                        >{{notification.message}}</b-alert>
                        
                        <form class="form-horizontal" @submit.prevent="tryToRegisterIn">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-user-2-line auti-custom-input-icon"></i>
                            <label for="username">{{ $t("register.username.text") }}</label>
                            <input
                              v-model="user.username"
                              type="text"
                              class="form-control"
                              id="username"
                              :class="{ 'is-invalid': submitted && $v.user.username.$error }"
                              :placeholder="$t('register.username.placeholder')"
                            />
                            <div
                              v-if="submitted && !$v.user.username.required"
                              class="invalid-feedback"
                            >{{ $t("register.username.noinput") }}</div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">{{ $t("register.email.text") }}</label>
                            <input
                              v-model="user.email"
                              type="email"
                              class="form-control"
                              id="useremail"
                              :placeholder="$t('register.email.placeholder')"
                              :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                            />
                            <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                              <span v-if="!$v.user.email.required">{{ $t("register.email.noinput") }}</span>
                              <span v-if="!$v.user.email.email">{{ $t("register.email.valid") }}</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon"></i>
                            <label for="userpassword">{{ $t("register.password.text") }}</label>
                            <input
                              v-model="user.password"
                              type="password"
                              class="form-control"
                              id="userpassword"
                              :placeholder="$t('register.password.placeholder')"
                              :class="{ 'is-invalid': submitted && $v.user.password.$error }"
                            />
                            <div
                              v-if="submitted && !$v.user.password.required"
                              class="invalid-feedback"
                            >{{ $t("register.password.noinput") }}</div>
                          </div>

                          <div class="text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >{{ $t("register.button") }}</button>
                          </div>

                          <div class="mt-4 text-center">
                            <div class="mb-2 text-left">
                              <label class="mb-2 d-flex align-items-start">
                                <input v-model="agreementChecked" type="checkbox" style="margin-top: 5px; margin-right: 8px;" />
                                <span>我已阅读并同意以下协议</span>
                              </label>
                              <ul class="mb-0 pl-4">
                                <li v-for="item in agreements" :key="item.key">
                                  <a href="#" class="text-primary" @click.prevent="openAgreement(item)">
                                    {{ item.title }}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          {{ $t("register.haveaccount") }}
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                          >{{ $t("register.login") }}</router-link>
                        </p>
                        <p>
                          © 2016 Shijiazhuang MOE Information Technology Co., Ltd<br/>
                          © 2015 AICO Group Limited company
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="agreementPreviewVisible"
      :title="currentAgreement ? currentAgreement.title : '协议预览'"
      width="80%"
      top="5vh"
      append-to-body
    >
      <iframe
        v-if="currentAgreement && currentAgreement.file"
        :src="currentAgreement.file"
        style="width: 100%; height: 70vh; border: none;"
      />
    </el-dialog>
  </div>
</template>